module.exports = __webpack_public_path__ + "img/desktop-bg.6c03a33b.png";